import React, { createContext, useCallback, useContext, useRef, useState } from "react";

type ToastState = { message: string; show: (msg: string) => void };

const ToastContext = createContext<ToastState | null>(null);

const AUTO_DISMISS_MS = 2800;

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [message, setMessage] = useState("");
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const show = useCallback((msg: string) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setMessage(msg);
    timerRef.current = setTimeout(() => setMessage(""), AUTO_DISMISS_MS);
  }, []);

  return (
    <ToastContext.Provider value={{ message, show }}>
      {children}
      {message && (
        <div className="nt-toast" role="status">
          <span className="nt-toast-mark" />
          {message}
        </div>
      )}
    </ToastContext.Provider>
  );
}

export function useToast(): (message: string) => void {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast precisa estar dentro de <ToastProvider>");
  return ctx.show;
}
